import { Flex } from "antd";
import type { ReactNode } from "react";

const StateCard = ({
  icon,
  title,
  count,
  iconClass,
  message,
}: {
  icon: ReactNode;
  title: string;
  count: string | number;
  iconClass?: string;
  message?: ReactNode;
}) => {
  return (
    <Flex
      className="bg-white p-4 rounded-lg shadow-md"
      align="center"
      justify="space-between"
      gap={12}
    >
      <div>
        <div className="justify-start text-slate-600 text-base font-normal">
          {title}
        </div>
        <div className="justify-start text-zinc-700 text-3xl font-bold">
          {count}
        </div>
        <div>{message}</div>
      </div>

      <div
        className={`p-2 ${iconClass} rounded-xl inline-flex justify-center items-center gap-2.5`}
      >
        {icon}
      </div>
    </Flex>
  );
};

export default StateCard;
